import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { BUXTON_META } from "./meta.ts";
import { parseBuxtonDetailHtml } from "./parser.ts";
import { buildPaginatedUrl, buildSearchUrl, parseBuxtonDiscoveryPreviews } from "./runtime.ts";

export * from "./meta.ts";
export * from "./parser.ts";
export * from "./runtime.ts";

export const BUXTON_ADAPTER = defineSoldOnlyAdapter(BUXTON_META, buildSearchUrl, {
  parseDetailHtml: parseBuxtonDetailHtml,
  // Direct fetch served its search and detail pages in full (probe, 2026-10-14).
  directFirst: true,
  // Slow under load (listings API ~5 s per 50 sales unloaded); 30 s timed out during backfills.
  directTimeoutMs: 90_000,
  // Discovery reads Buxton's listings API (every sale, newest first), not the 12-card search page.
  buildPaginatedUrl,
  parseDiscoveryPreviews: parseBuxtonDiscoveryPreviews,
});
